import axios from 'axios';
import { notify } from '@kyvg/vue3-notification';
import store from '@/state/store';
import router from '@/router';

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL+"/api/v1",
  headers: {
    'Content-Type': 'application/json',
  },
});


// Add a request interceptor to dynamically set the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Fetch the token from localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // store.commit('layout/LOADER', true); // Show the loader
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // store.commit('layout/LOADER', false); // Show the loader
    if (response.config.method !== 'get') {
      notify({
        type: 'success',
        title: 'Success',
        text: response.data.message || 'Request completed successfully',
      });
    }
    return response; // Centralize response handling
  },
  (error) => {
    // store.commit('layout/LOADER', false); // Show the loader
    if (error.response?.status === 401) {
      store.dispatch('authApi/logout'); // Clear the token and logout
      router.push({ name: 'Login' });
    }
    notify({
      type: 'error',
      title: 'Error',
      text: error.response?.data?.message || 'An error occurred',
    });
    return Promise.reject(error);
  }
);

export default api;
